/**
 * What things mean, in one place: the tips a mouse shows on hover and a phone shows on press and
 * hold (LongPressTips.tsx). Wording shared by several screens lives here so it says the same
 * thing everywhere; a tip that belongs to one control stays beside it.
 *
 * e2e/tip-audit.mjs lists any control without a tip; CI fails on one.
 */

/** Each race view, by its tab id (race page, RaceTrace Live, qualifying). */
export const VIEW_TIPS: Record<string, string> = {
  story: "The race's story: what happened to your car and its class, written from the race's analysis.",
  position: "Position Trace: every car's place, lap by lap, your car in orange. Tap a lap for its details; pinch or double-tap to zoom.",
  cards: "Race cards: images of your car's race and of each of its drivers, ready to share. Swipe between them.",
  pitanalysis: "Pit stops: each car's stops in its class, ranked by time lost, time in the pit lane and places gained.",
  cycle: "Pit cycle: the class order before and after a round of stops, and who gained or lost places in it.",
  laptimes: "Times: your car's laps, its best in green, and its race average up to each lap. Chart shows every car's lap-time rank.",
  gaps: "Gap evolution: the gap from your car to the car you pick, lap by lap, and where it is heading at this pace.",
  h2h: "Head-to-head: your car against one rival, lap by lap: average and best laps, laps quicker, and the gap.",
  strategy: "Strategy: each car's stints and stops, its pace and time in the pits, ranked across the class.",
  drivers: "Driver Report: each driver's pace, consistency, clean air and passes, ranked in the class.",
  map: "Track map: every car's place on the circuit now. Tap a car to follow it.",
  stats: "Qualifying stats: each car's best lap, theoretical best and sectors, ranked.",
  trace: "Sector trace: each car's sector times, lap by lap.",
};

/** A class button: show that class. */
export const classTip = (cls: string) => (cls ? `Show the ${cls} class` : "Show every class");

/** A car in a list that makes it the focus car when tapped. */
export const focusCarTip = (label: string) => `Make ${label} the focus car: the one every view is about`;

/** Seen on several pages. */
export const TIPS = {
  focusPill: "The focus car, and how many cars it is compared with. Tap to pick another car or change the comparison.",
  compare: "Compare cars side by side: tap up to three rows, then Compare. (Or press and hold a row.)",
  rotate: "Turn the phone sideways for the full table",
  prevLap: "The lap before",
  nextLap: "The next lap",
  prevStop: "The stop before",
  nextStop: "The next stop",
  lapPeek: "The lap picked: tap to open its details, or drag the panel up",
  axisLaps: "Count along the bottom in laps",
  axisTime: "Count along the bottom in race time",
  axisBoth: "Show laps and race time along the bottom",
  close: "Close",
  done: "Done: keep these cars",
  raceMenu: "Race menu: share, star, PDF, other races this weekend",
} as const;
